<template>
  <nav
    v-if="items.length > 0"
    class="flex py-4 md:py-7"
    :aria-label="t('menu.breadcrumb.breadcrumb')"
  >
    <span
      v-if="items.length > 2"
      aria-hidden="true"
      class="block md:hidden self-center text-xs font-bold text-gray-500"
      >...</span
    >
    <svg
      v-if="items.length > 2"
      class="block md:hidden mx-1 h-5 w-5 shrink-0 text-gray-500"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fill-rule="evenodd"
        d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
        clip-rule="evenodd"
      />
    </svg>
    <UBreadcrumb
      as="div"
      :items="breadcrumbItems"
      separator-icon="i-heroicons-chevron-right-20-solid"
    />
  </nav>
</template>

<script setup lang="ts">
import type { BreadcrumbItem } from '@nuxt/ui'
import { useMenuBreadcrumb } from '../composables/useMenuBreadcrumb'

const { items } = useMenuBreadcrumb()

const breadcrumbItems = computed<BreadcrumbItem[]>(() =>
  items.value.map((item, index) => {
    const isHiddenOnMobile = index < items.value.length - 2
    return {
      ...item,
      ...(isHiddenOnMobile
        ? {
            ui: {
              item: 'hidden md:flex min-w-0',
              separator: 'hidden md:flex',
            },
          }
        : {}),
    }
  }),
)
</script>
